export const BASE_PATH_TO_PURCHASE = "/purchase";

// ==============================|| POINTS PURCHASE VOUCHERS ||============================== //

export const BASE_PATH_TO_POINT_PURCHASE_VOUCHERS_LIST = `${BASE_PATH_TO_PURCHASE}/point-purchase-vouchers`;
export const BASE_PATH_TO_ADD_POINT_PURCHASE_VOUCHERS = `${BASE_PATH_TO_PURCHASE}/add-point-purchase-vouchers`;
export const BASE_PATH_TO_UPDATE_POINT_PURCHASE_VOUCHERS = `${BASE_PATH_TO_PURCHASE}/update-point-purchase-vouchers`;

export const BASE_PATH_TO_PHONE_PE_PAYMENT_INIT_LIST = `${BASE_PATH_TO_PURCHASE}/phone-pe-payment-init`;